import { useCallback, useMemo } from 'react';
import { API } from '@shared/types/api';
import { notNil } from '@shared/util/notNil';
import * as Actions from '../store/actions';

export function useToggleReaction(message: API.ChatMessageFragment, channelSlug: string) {
  return useCallback(
    (reaction: API.ReactionType, add: boolean) =>
      Actions.toggleReaction(message, channelSlug, reaction, add),
    [message, channelSlug],
  );
}

export function useSelectedReactions(message: API.ChatMessageFragment): API.ReactionType[] {
  return useMemo(() => {
    const reactions: API.ReactionFragment[] = message.meta.reactions.filter(notNil) ?? [];
    return reactions.filter(reaction => reaction.user.isMe).map(reaction => reaction.type);
  }, [message.meta.reactions]);
}
